module.exports = __webpack_public_path__ + "static/medograf-casebg@2x-min-474068826bcffd4bd1f83299fd5c8f72.jpg";